(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-tabs"] && !Shopify.designMode) return;
  try {
    
  function bsInitAll() {
    document.querySelectorAll('.bs').forEach(function (root) {
      if (root.dataset.bsInit) return;
      root.dataset.bsInit = 'true';

      // Tab switching
      var tabs = root.querySelectorAll('.bs__tab');
      var panels = root.querySelectorAll('.bs__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-bs-tab');
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('bs__tab--active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('bs__panel--active', p.getAttribute('data-bs-panel') === index);
          });
          requestAnimationFrame(function () {
            var activePanel = root.querySelector('.bs__panel--active');
            root.querySelectorAll('.bs__grid-wrap').forEach(function (wrap) {
              var isActive = activePanel && activePanel.contains(wrap);
              if (isActive) {
                if (typeof wrap._bsUpdateArrows === 'function') wrap._bsUpdateArrows();
                if (typeof wrap._bsStartAutoplay === 'function') wrap._bsStartAutoplay();
              } else if (typeof wrap._bsStopAutoplay === 'function') {
                wrap._bsStopAutoplay();
              }
            });
          });
        });
      });

      // Slider arrows + autoplay (shown/enabled only when the grid is actually scrollable)
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.querySelectorAll('.bs__grid-wrap').forEach(function (wrap) {
        var grid = wrap.querySelector('.bs__grid');
        var prevBtn = wrap.querySelector('[data-bs-grid-prev]');
        var nextBtn = wrap.querySelector('[data-bs-grid-next]');
        if (!grid || !prevBtn || !nextBtn) return;

        var autoplayEnabled = wrap.getAttribute('data-bs-autoplay') === 'true';
        var intervalMs = parseInt(wrap.getAttribute('data-bs-interval'), 10) || 4000;
        var timer = null;

        function scrollAmount() {
          var firstCard = grid.children[0];
          if (!firstCard) return grid.clientWidth;
          var style = getComputedStyle(grid);
          var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        }

        function isScrollable() {
          return grid.scrollWidth > grid.clientWidth + 4;
        }

        function updateArrows() {
          var scrollable = isScrollable();
          prevBtn.style.display = scrollable ? 'flex' : 'none';
          nextBtn.style.display = scrollable ? 'flex' : 'none';
        }

        function advance() {
          var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
          if (atEnd) {
            grid.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
          }
        }

        function stopAutoplay() {
          if (timer) clearInterval(timer);
          timer = null;
        }

        function startAutoplay() {
          stopAutoplay();
          if (!autoplayEnabled || reduceMotion) return;
          var panel = wrap.closest('.bs__panel');
          if (panel && !panel.classList.contains('bs__panel--active')) return;
          if (!isScrollable()) return;
          timer = setInterval(advance, intervalMs);
        }

        prevBtn.addEventListener('click', function () {
          grid.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
          grid.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });

        wrap.addEventListener('mouseenter', stopAutoplay);
        wrap.addEventListener('mouseleave', startAutoplay);
        wrap.addEventListener('touchstart', stopAutoplay, { passive: true });

        grid.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', function () {
          updateArrows();
          startAutoplay();
        });

        wrap._bsUpdateArrows = updateArrows;
        wrap._bsStartAutoplay = startAutoplay;
        wrap._bsStopAutoplay = stopAutoplay;

        updateArrows();
        startAutoplay();
      });

      // Variant selects
      root.querySelectorAll('[data-bs-variant-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          var card = select.closest('[data-bs-card]');
          if (!card) return;
          var jsonEl = card.querySelector('[data-bs-variant-json]');
          if (!jsonEl) return;

          var variants;
          try {
            variants = JSON.parse(jsonEl.textContent);
          } catch (e) {
            return;
          }

          var match = variants.find(function (v) {
            return v.option1 === select.value || v.option2 === select.value || v.option3 === select.value;
          });

          var atcButton = card.querySelector('[data-bs-atc]');
          var priceCurrent = card.querySelector('[data-bs-price-current]');
          var priceCompare = card.querySelector('[data-bs-price-compare]');

          if (match) {
            atcButton.dataset.variantId = match.id;
            atcButton.disabled = !match.available;
            if (priceCurrent) priceCurrent.textContent = formatMoney(match.price);
            if (priceCompare) {
              if (match.compare_at_price && match.compare_at_price > match.price) {
                priceCompare.textContent = formatMoney(match.compare_at_price);
                priceCompare.hidden = false;
              } else {
                priceCompare.hidden = true;
              }
            }
          } else {
            atcButton.disabled = true;
          }
        });
      });

      // Add to cart
      root.querySelectorAll('[data-bs-atc]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          var variantId = button.dataset.variantId;

          if (!variantId) {
            console.warn('[Best Sellers] No purchasable variant for this product — button left disabled.');
            return;
          }

          button.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw new Error(err.description || 'Add to cart failed');
                });
              }
              return res.json();
            })
            .then(function () {
              button.classList.add('bs-card__atc--added');
              return openCartDrawer();
            })
            .then(function () {
              setTimeout(function () {
                button.classList.remove('bs-card__atc--added');
                button.disabled = false;
              }, 1200);
            })
            .catch(function (err) {
              console.warn('[Best Sellers] Add to cart error:', err);
              button.disabled = false;
              alert('Sorry, that item could not be added to your cart. ' + (err.message || ''));
            });
        });
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');

    if (!drawer) {
      // No native cart drawer found on this page/theme — safest fallback
      window.location.href = '/cart';
      return Promise.resolve();
    }

    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var freshDrawer = parsed.querySelector('cart-drawer');
          if (freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
        }

        if (sections['cart-icon-bubble']) {
          var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var freshBubble = parsedBubble.getElementById('cart-icon-bubble');
          var currentBubble = document.getElementById('cart-icon-bubble');
          if (freshBubble && currentBubble) currentBubble.innerHTML = freshBubble.innerHTML;
        }

        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('animate', 'active');
        }
      })
      .catch(function (err) {
        console.warn('[Best Sellers] Could not refresh cart drawer, redirecting to cart page instead:', err);
        window.location.href = '/cart';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bsInitAll);
  } else {
    bsInitAll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-and-use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoTriggers(root) {
      root.querySelectorAll('[data-care-video-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.care-row');
          var modal = row ? row.querySelector('[data-care-video-modal]') : null;
          if (modal) modal.hidden = false;
        });
      });

      root.querySelectorAll('[data-care-video-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var modal = btn.closest('[data-care-video-modal]');
          if (!modal) return;
          modal.hidden = true;
          var iframe = modal.querySelector('iframe');
          if (iframe) iframe.src = iframe.src;
        });
      });

      root.querySelectorAll('[data-care-video-modal]').forEach(function (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) {
            modal.hidden = true;
            var iframe = modal.querySelector('iframe');
            if (iframe) iframe.src = iframe.src;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.care-guide').forEach(function (root) {
        if (root.dataset.careInit) return;
        root.dataset.careInit = 'true';
        initVideoTriggers(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoTriggers(root) {
      root.querySelectorAll('[data-care-video-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.care-row');
          var modal = row ? row.querySelector('[data-care-video-modal]') : null;
          if (modal) modal.hidden = false;
        });
      });

      root.querySelectorAll('[data-care-video-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var modal = btn.closest('[data-care-video-modal]');
          if (!modal) return;
          modal.hidden = true;
          var iframe = modal.querySelector('iframe');
          if (iframe) iframe.src = iframe.src;
        });
      });

      root.querySelectorAll('[data-care-video-modal]').forEach(function (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) {
            modal.hidden = true;
            var iframe = modal.querySelector('iframe');
            if (iframe) iframe.src = iframe.src;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.care-guide').forEach(function (root) {
        if (root.dataset.careInit) return;
        root.dataset.careInit = 'true';
        initVideoTriggers(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-mascot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqMascot(root) {
      var items = root.querySelectorAll('[data-faqm-item]');
      var mascot = root.querySelector('[data-faqm-mascot]');
      var bubble = root.querySelector('[data-faqm-bubble]');
      var defaultText = bubble ? bubble.textContent : '';

      items.forEach(function (item) {
        var question = item.querySelector('[data-faqm-question]');
        question.addEventListener('click', function () {
          var isOpen = item.classList.contains('faqm--open');

          items.forEach(function (i) {
            i.classList.remove('faqm--open');
          });

          if (!isOpen) {
            item.classList.add('faqm--open');

            if (bubble) {
              var reaction = item.getAttribute('data-faqm-reaction');
              bubble.textContent = reaction || defaultText;
            }

            if (mascot) {
              mascot.classList.remove('faqm--flinch');
              void mascot.offsetWidth;
              mascot.classList.add('faqm--flinch');
            }
          } else if (bubble) {
            bubble.textContent = defaultText;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.faqm').forEach(function (root) {
        if (root.dataset.faqmInit) return;
        root.dataset.faqmInit = 'true';
        initFaqMascot(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function sleep(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    async function talkLoop(root) {
      var textEl = root.querySelector('[data-jx-speech-text]');
      var dotsEl = root.querySelector('[data-jx-typing-dots]');
      var dataEl = root.querySelector('[data-jx-dialogues]');
      if (!textEl || !dotsEl) return;

      var messages = ['Hello!'];
      if (dataEl) {
        try {
          var parsed = JSON.parse(dataEl.textContent);
          if (Array.isArray(parsed) && parsed.length > 0) messages = parsed;
        } catch (e) {
          /* keep default */
        }
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion) {
        textEl.textContent = messages[0];
        dotsEl.style.display = 'none';
        return;
      }

      var index = 0;
      while (true) {
        var message = messages[index % messages.length];

        dotsEl.style.display = 'flex';
        textEl.style.display = 'none';
        textEl.textContent = '';
        await sleep(1300);

        dotsEl.style.display = 'none';
        textEl.style.display = 'block';
        textEl.innerHTML = '<span class="jx__cursor"></span>';
        var shown = '';
        for (var i = 0; i < message.length; i++) {
          shown += message[i];
          textEl.innerHTML = shown + '<span class="jx__cursor"></span>';
          await sleep(38);
        }
        textEl.innerHTML = shown;

        await sleep(2600);
        index++;
      }
    }

    function initCardsCarousel(root) {
      var track = root.querySelector('[data-jx-cards-track]');
      if (!track) return;

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-jx-card]'));
      var prevBtn = root.querySelector('[data-jx-cards-prev]');
      var nextBtn = root.querySelector('[data-jx-cards-next]');
      if (cards.length === 0) return;

      var current = 0;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function visibleCount() {
        var raw = getComputedStyle(root).getPropertyValue('--jx-cards-visible');
        var n = parseInt(raw, 10);
        return n > 0 ? n : 1;
      }

      function maxIndex() {
        return Math.max(cards.length - visibleCount(), 0);
      }

      function update() {
        var vc = visibleCount();
        var mx = maxIndex();
        current = Math.min(current, mx);
        track.style.transform = 'translateX(-' + (current * (100 / vc)) + '%)';

        if (prevBtn) prevBtn.style.display = mx > 0 ? 'flex' : 'none';
        if (nextBtn) nextBtn.style.display = mx > 0 ? 'flex' : 'none';
      }

      function goTo(index) {
        var mx = maxIndex();
        if (index < 0) index = mx;
        if (index > mx) index = 0;
        current = index;
        update();
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });

      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      var intervalMs = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      var timer = null;

      function startAutoplay() {
        if (!autoplayEnabled || reduceMotion || maxIndex() === 0) return;
        stopAutoplay();
        timer = setInterval(next, intervalMs);
      }
      function stopAutoplay() {
        if (timer) clearInterval(timer);
      }
      function resetAutoplay() {
        startAutoplay();
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      window.addEventListener('resize', function () {
        update();
        resetAutoplay();
      });

      update();
      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('.journalx').forEach(function (root) {
        if (root.dataset.jxInit) return;
        root.dataset.jxInit = 'true';
        talkLoop(root);

        var cardsRoot = root.querySelector('[data-jx-cards]');
        if (cardsRoot) initCardsCarousel(cardsRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      var tabs = root.querySelectorAll('[data-glx-tab]');
      var panels = root.querySelectorAll('[data-glx-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-glx-tab');

          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('glx__tab--active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function (p) {
            p.classList.toggle('glx__panel--active', p.getAttribute('data-glx-panel') === target);
          });
        });
      });
    }

    function initPagination(root) {
      var grids = root.querySelectorAll('[data-glx-grid]');

      grids.forEach(function (grid) {
        var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 6;
        var items = Array.prototype.slice.call(grid.querySelectorAll('[data-glx-item]'));
        var loadMoreBtn = grid.parentElement.querySelector('[data-glx-load-more]');
        var visibleCount = perPage;

        function render() {
          items.forEach(function (item, i) {
            if (i < visibleCount) {
              item.removeAttribute('data-glx-hidden');
            } else {
              item.setAttribute('data-glx-hidden', 'true');
            }
          });

          if (loadMoreBtn) {
            loadMoreBtn.hidden = visibleCount >= items.length;
          }
        }

        if (loadMoreBtn) {
          loadMoreBtn.addEventListener('click', function () {
            visibleCount += perPage;
            render();
          });
        }

        render();
      });
    }

    function initAll() {
      document.querySelectorAll('.glx').forEach(function (root) {
        if (root.dataset.glxInit) return;
        root.dataset.glxInit = 'true';
        initTabs(root);
        initPagination(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function mcpgFormatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function mcpgOpenCartDrawer() {
      var drawer = document.querySelector('cart-drawer');

      if (!drawer) {
        window.location.href = '/cart';
        return Promise.resolve();
      }

      return fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) {
          return res.json();
        })
        .then(function (sections) {
          if (sections['cart-drawer']) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var freshDrawer = parsed.querySelector('cart-drawer');
            if (freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
          }
          if (sections['cart-icon-bubble']) {
            var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var freshBubble = parsedBubble.getElementById('cart-icon-bubble');
            var currentBubble = document.getElementById('cart-icon-bubble');
            if (freshBubble && currentBubble) currentBubble.innerHTML = freshBubble.innerHTML;
          }
          if (typeof drawer.open === 'function') {
            drawer.open();
          } else {
            drawer.classList.add('animate', 'active');
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    }

    function mcpgInitCard(card) {
      if (card.dataset.mcpgInit) return;
      card.dataset.mcpgInit = 'true';

      var select = card.querySelector('[data-bs-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          var jsonEl = card.querySelector('[data-bs-variant-json]');
          if (!jsonEl) return;

          var variants;
          try {
            variants = JSON.parse(jsonEl.textContent);
          } catch (e) {
            return;
          }

          var match = variants.find(function (v) {
            return v.option1 === select.value || v.option2 === select.value || v.option3 === select.value;
          });

          var atcButton = card.querySelector('[data-bs-atc]');
          var priceCurrent = card.querySelector('[data-bs-price-current]');
          var priceCompare = card.querySelector('[data-bs-price-compare]');

          if (match) {
            atcButton.dataset.variantId = match.id;
            atcButton.disabled = !match.available;
            if (priceCurrent) priceCurrent.textContent = mcpgFormatMoney(match.price);
            if (priceCompare) {
              if (match.compare_at_price && match.compare_at_price > match.price) {
                priceCompare.textContent = mcpgFormatMoney(match.compare_at_price);
                priceCompare.hidden = false;
              } else {
                priceCompare.hidden = true;
              }
            }
          } else {
            atcButton.disabled = true;
          }
        });
      }

      var atcButton = card.querySelector('[data-bs-atc]');
      if (atcButton) {
        atcButton.addEventListener('click', function () {
          if (atcButton.disabled) return;
          var variantId = atcButton.dataset.variantId;
          if (!variantId) return;

          atcButton.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw new Error(err.description || 'Add to cart failed');
                });
              }
              return res.json();
            })
            .then(function () {
              atcButton.classList.add('bs-card__atc--added');
              return mcpgOpenCartDrawer();
            })
            .then(function () {
              setTimeout(function () {
                atcButton.classList.remove('bs-card__atc--added');
                atcButton.disabled = false;
              }, 1200);
            })
            .catch(function (err) {
              console.warn('[Collection grid] Add to cart error:', err);
              atcButton.disabled = false;
              alert('Sorry, that item could not be added to your cart. ' + (err.message || ''));
            });
        });
      }
    }

    function mcpgInitAll() {
      document.querySelectorAll('.bs-card[data-bs-card]').forEach(mcpgInitCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mcpgInitAll);
    } else {
      mcpgInitAll();
    }

    document.addEventListener('facet:updated', mcpgInitAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqMascot(root) {
      var items = root.querySelectorAll('[data-faqm-item]');
      var mascot = root.querySelector('[data-faqm-mascot]');
      var bubble = root.querySelector('[data-faqm-bubble]');
      var defaultText = bubble ? bubble.textContent : '';

      items.forEach(function (item) {
        var question = item.querySelector('[data-faqm-question]');
        question.addEventListener('click', function () {
          var isOpen = item.classList.contains('faqm--open');

          items.forEach(function (i) {
            i.classList.remove('faqm--open');
          });

          if (!isOpen) {
            item.classList.add('faqm--open');

            if (bubble) {
              var reaction = item.getAttribute('data-faqm-reaction');
              bubble.textContent = reaction || defaultText;
            }

            if (mascot) {
              mascot.classList.remove('faqm--flinch');
              void mascot.offsetWidth;
              mascot.classList.add('faqm--flinch');
            }
          } else if (bubble) {
            bubble.textContent = defaultText;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.faqm').forEach(function (root) {
        if (root.dataset.faqmInit) return;
        root.dataset.faqmInit = 'true';
        initFaqMascot(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var track = root.querySelector('[data-rvc-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rvc-slide]'));
      var prevBtn = root.querySelector('[data-rvc-prev]');
      var nextBtn = root.querySelector('[data-rvc-next]');
      if (slides.length === 0) return;

      var current = 0;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setHeight() {
        var active = slides[current];
        track.style.height = active.offsetHeight + 'px';
      }

      function goTo(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          slide.classList.toggle('rvc__slide--active', i === current);
        });

        requestAnimationFrame(setHeight);
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });

      var autoplayEnabled = track.getAttribute('data-autoplay') === 'true';
      var intervalMs = parseInt(track.getAttribute('data-interval'), 10) || 5000;
      var timer = null;

      function startAutoplay() {
        if (!autoplayEnabled || reduceMotion || slides.length < 2) return;
        stopAutoplay();
        timer = setInterval(next, intervalMs);
      }
      function stopAutoplay() {
        if (timer) clearInterval(timer);
      }
      function resetAutoplay() {
        startAutoplay();
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      window.addEventListener('resize', setHeight);

      setHeight();
      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('.rvc').forEach(function (root) {
        if (root.dataset.rvcInit) return;
        root.dataset.rvcInit = 'true';
        initCarousel(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatNumber(value, decimals, prefix, suffix) {
      return prefix + value.toFixed(decimals) + suffix;
    }

    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-stat-value')) || 0;
      var decimals = parseInt(el.getAttribute('data-stat-decimals'), 10) || 0;
      var prefix = el.getAttribute('data-stat-prefix') || '';
      var suffix = el.getAttribute('data-stat-suffix') || '';
      var duration = parseFloat(el.getAttribute('data-stat-duration')) || 2;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = formatNumber(target, decimals, prefix, suffix);
        return;
      }

      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target * eased;
        el.textContent = formatNumber(current, decimals, prefix, suffix);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = formatNumber(target, decimals, prefix, suffix);
        }
      }

      window.requestAnimationFrame(step);
    }

    function initStatCounters() {
      var els = document.querySelectorAll('[data-stat-value]');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        els.forEach(animateCount);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateCount(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      els.forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatCounters);
    } else {
      initStatCounters();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCycle(root) {
      var el = root.querySelector('[data-vhero-cycle]');
      var dataEl = root.querySelector('[data-vhero-words]');
      if (!el || !dataEl) return;

      var words = [];
      try {
        words = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (words.length < 2) return;

      var intervalMs = parseFloat(el.getAttribute('data-interval')) || 2500;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;

      setInterval(function () {
        index = (index + 1) % words.length;

        if (reduceMotion) {
          el.textContent = words[index];
          return;
        }

        el.classList.add('vhero--fading');
        setTimeout(function () {
          el.textContent = words[index];
          el.classList.remove('vhero--fading');
        }, 350);
      }, intervalMs);
    }

    function initAll() {
      document.querySelectorAll('.vhero').forEach(function (root) {
        if (root.dataset.vheroInit) return;
        root.dataset.vheroInit = 'true';
        initCycle(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tips"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoTriggers(root) {
      root.querySelectorAll('[data-video-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.video-card');
          var modal = card ? card.querySelector('[data-video-modal]') : null;
          if (modal) modal.hidden = false;
        });
      });

      root.querySelectorAll('[data-video-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var modal = btn.closest('[data-video-modal]');
          if (!modal) return;
          modal.hidden = true;
          var iframe = modal.querySelector('iframe');
          if (iframe) iframe.src = iframe.src;
          var video = modal.querySelector('video');
          if (video) video.pause();
        });
      });

      root.querySelectorAll('[data-video-modal]').forEach(function (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) {
            modal.hidden = true;
            var iframe = modal.querySelector('iframe');
            if (iframe) iframe.src = iframe.src;
            var video = modal.querySelector('video');
            if (video) video.pause();
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.video-tips').forEach(function (root) {
        if (root.dataset.vtInit) return;
        root.dataset.vtInit = 'true';
        initVideoTriggers(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-chosse-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wraps = [];

    function collectWraps() {
      wraps = Array.prototype.slice.call(document.querySelectorAll('.wcu__mosquito-wrap[data-wcu-parallax]'));
    }

    function updateParallax() {
      wraps.forEach(function (el) {
        var section = el.closest('.wcu');
        if (!section) return;
        var factor = parseFloat(el.getAttribute('data-wcu-parallax')) || 0;
        var rect = section.getBoundingClientRect();
        var offset = rect.top * factor;
        el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateParallax();
        ticking = false;
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        collectWraps();
        updateParallax();
      });
    } else {
      collectWraps();
      updateParallax();
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  })();

  } catch(e) { console.error(e); }
})();
})();
